import Vue from "vue";
import Vuex from "vuex";

import dayjs from "dayjs";
Vue.use(Vuex);
// 保存初始state（根模块 + 所有子模块）
const initialState = () => ({
  state: {
    userInfo: {
      companyHistoryList: [],
      companyInfo: {},
      companyMembers: [],
      loginUser: {},
      studioHistoryList: [],
      studioInfo: {},
      studioMembers: [],
    },
    paramsId: {
      companyId: "", // 企业/工作室 id 用户传空
      userId: "", // 个人的传，企业公司传空
    },
    activeCompanyInfo: {
      city: "",
      companyArea: "",
      companyAvatar: "",
      companyBusinessBackUrl: "",
      companyBusinessUrl: "",
      companyContent: "",
      companyEmail: "",
      companyName: "",
      companyNum: "",
      companyProfession: "",
      companyTel: "",
      companyWx: "",
      country: "",
      history: "",
      id: "",
      mission: "",
      province: "",
      status: "",
      type: "",
      userId: null,
      vision: "",
    },
    usedAppId: null,
    brandLogo: {
      fileUrl: "",
    },
    historyList: [
      {
        historyTime: dayjs().format("YYYY-MM"),
        history: null,
      },
    ],
  },
});
export default new Vuex.Store({
  state: initialState().state,
  getters: {},
  mutations: {
    //修改当前操作项目
    SET_USERINFO(state, info) {
      state.userInfo = info;
    },
    SET_PARAMSID(state, info) {
      state.paramsId = info;
    },
    SET_ACTIVECOMPANYINFO(state, info) {
      state.activeCompanyInfo = info;
    },
    SET_APP_ID(state, info) {
      state.usedAppId = info;
    },
    SET_BRAND_LOGO(state, info) {
      state.brandLogo = info;
    },
    SET_HISTORY_LIST(state, info) {
      state.historyList = info;
    },
    // 重置整个state的方法
    RESET_ALL_STATE(state) {
      const initState = initialState().state;
      // 覆盖当前state为初始值
      Object.keys(initState).forEach((key) => {
        state[key] = initState[key];
      });
    },
  },
  actions: {},
  modules: {},
});
